export const FR_TRANSLATIONS = {
  "language": {
    "genCode": "fr",
    "localeCode": "fr",
    "name": "Français"
  },
  "header": {
    "login": "Connexion",
    "register": "S’inscrire",
    "help": "Aide",
    "assessment": "Évaluation",
    "continueIbis": "Continuer vers IBIS",
    "students": "Étudiants",
    "requestResults": "Demander un remplacement des résultats",
    "copyright": "© Organisation du Baccalauréat International, 2026",
    "languagePolicy": "Politique linguistique",
    "terms": "Conditions générales",
    "privacy": "Politique de confidentialité de l’IB",
    "myIB": "Mon IB",
    "store": "Magasin de l’IB",
    "blogs": "Blogues",
    "askQuestion": "Poser une question",
    "ibis": "Système d'information de l'IB"
  },

  "auth": {
    "welcome": "Bienvenue.",
    "movedSystem": "Nous avons mis en place un système de connexion plus simple et plus sécurisé. Pour commencer, choisissez une option ci-dessous.",
    "firstTime": "C’est votre première utilisation du nouveau système de connexion",
    "setupPassword": "Configurer un nouveau mot de passe",
    "alreadySetup": "Vous avez déjà configuré un nouveau mot de passe",
    "fantastic": "Fantastique ! Vous pouvez maintenant vous connecter avec votre nouveau mot de passe."
  },

  "register": {
    "title": "Créer mon compte",
    "alreadyAccount": "Vous avez déjà un compte ?",
    "loginHere": "Connectez-vous ici",
    "troubleAccess": "Vous avez des difficultés à accéder à votre compte ?",
    "contactUs": "Contactez-nous",
    "firstName": "Prénom",
    "lastName": "Nom",
    "salutation": "Civilité",
    "dob": "Date de naissance",
    "countryOfBirth": "Pays ou territoire de naissance",
    "placeOfBirth": "Lieu de naissance",
    "preferredLanguage": "Langue préférée",
    "selectOption": "Sélectionner une option",
    "emailWarning": "Attention : votre adresse e-mail sera votre identifiant unique.",
    "emailLongTerm": "Veuillez choisir une adresse e-mail à laquelle vous aurez accès à long terme.",
    "email": "Adresse e-mail",
    "confirmEmail": "Confirmer l’adresse e-mail",
    "password": "Mot de passe",
    "confirmPassword": "Confirmer le mot de passe",
    "schoolEmail": "Adresse e-mail scolaire",
    "connectedAccount": "Associée à votre compte",
    "agreeTerms": "J’accepte les conditions générales de l’IB",
    "submit": "Créer mon compte",
    "privacyNote": "Toutes les données personnelles seront traitées conformément à la politique de confidentialité de l’IB",
    "warningTitle": "Avertissement :",
    "warningText": "Votre adresse e-mail sera votre identifiant unique.",
    "warningNote": "Veuillez choisir une adresse e-mail à laquelle vous aurez accès à long terme.",
    "warningLastPrefix": "Pour modifier ces informations ultérieurement, vous devrez",
    "warningLastLink": "demander une modification manuelle.",
    "select": "Aucun",
    "agree": "J’accepte",
    "terms": "IB’s Conditions générales",
    "privacyPrefix": "Toutes les données personnelles seront traitées conformément à",
    "privacyLink": "la politique de confidentialité de l’IB"
  },

  "success": {
    "title": "Vous y êtes presque.",
    "accountReady": "Vous pouvez maintenant accéder à MY IB et aux autres outils en ligne de l'IB.",
    "confirmEmail": "Nous vous avons envoyé un courriel contenant des instructions pour vous connecter à Mon IB. Veuillez consulter votre boîte de réception et suivre les étapes fournies.",
    "arrivalTime": "Vous devriez le recevoir d'ici quelques minutes.",
    "startBrowsing": "Retour à la connexion"
  },

  "confirmation": {
    "emailSent": "Nous vous avons envoyé un courriel contenant des instructions pour vous connecter à Mon IB. Veuillez consulter votre boîte de réception et suivre les étapes fournies."
  },

  "common": {
    "back": "Retour",
    "cancel": "Annuler",
    "backToLogin": "Retour à la page de connexion"
  },

  "login": {
    "email": "Adresse e-mail",
    "password": "Mot de passe",
    "login": "Connexion",
    "noAccount": "Vous n’avez pas de compte ?",
    "registerNow": "Inscrivez-vous."
  },

  "passwordReset": {
    "title": "Configurer un nouveau mot de passe",
    "instruction": "Pour utiliser le nouveau système, vous devez réinitialiser votre mot de passe lors de votre première connexion.",
    "emailAddress": "Adresse e-mail",
    "next": "Suivant",
    "verifyOtp": "Vérifier le code OTP",
    "otpInstruction": "Entrez le code à 6 chiffres envoyé à votre adresse e-mail",
    "otpSentTo": "Code envoyé à",
    "enterOtp": "Entrer le code",
    "resendOtp": "Renvoyer le code",
    "resetPassword": "Réinitialiser le mot de passe",
    "resettingFor": "Réinitialisation du mot de passe pour",
    "newPassword": "Nouveau mot de passe",
    "enterNewPassword": "Entrer un nouveau mot de passe",
    "confirmNewPassword": "Confirmer le nouveau mot de passe",
    "securityVerification": "Vérification de sécurité",
    "verificationSuccess": "Vérification réussie"
  },
  "errors": {
    "required": "{field} est requis.",
    "passwordPattern": "Le mot de passe doit contenir une majuscule, un chiffre et un caractère spécial.",
    "invalidEmail": "Entrez une adresse e-mail valide.",
    "invalidDate": "Entrez une date de naissance valide. Vous devez avoir au moins 18 ans.",
    "invalidLeapYearDate": "Saisissez une date de naissance valide. Le 29 février n'est valide que lors d'une année bissextile.",    "invalidDateFormat": "Le format de la date de naissance est invalide. Veuillez utiliser le format DD/MM/YYYY.",    "emailMismatch": "L’e-mail et la confirmation doivent correspondre.",
    "passwordMismatch": "Le mot de passe et sa confirmation doivent correspondre.",
    "minLength": "Minimum {{length}} caractères requis.",
    "maxLength": "Ne doit pas dépasser {{max}} caractères.",
    "linkNotWorking": "Ce lien ne semble plus fonctionner. Veuillez en demander un nouveau.",
    "requiredFieldsInvalid": "Veuillez vérifier que tous les champs obligatoires sont correctement remplis.",
    "acceptTerms": "Veuillez accepter les Conditions générales de l’IB pour continuer.",
    "genericServerError": "Une erreur s’est produite de notre côté. Veuillez réessayer dans quelques minutes.",
    "linkAlreadyUsed": "Ce lien a déjà été utilisé. Essayez plutôt de vous connecter.",
    "emailAlreadyUsed": "Un enregistrement avec ces détails existe déjà.",
    "nameTooLong": "Votre nom est trop long. Il ne doit pas excéder 40 caractères.",
    "invalidInformation": "Certaines informations semblent erronées. Veuillez vérifier et réessayer.",
    "sessionVerificationFailed": "Nous n’avons pas pu vérifier votre session. Veuillez actualiser la page et réessayer.",
    "tooManyAttempts": "Trop de tentatives. Veuillez patienter quelques instants avant de réessayer.",
    "registrationUnavailable": "L’inscription est temporairement indisponible. Veuillez réessayer dans quelques minutes.",
    "offline": "Il semblerait que vous soyez hors ligne. Veuillez vérifier votre connexion et réessayer.",
    "weakPassword": "Le mot de passe que vous avez saisi n'est pas autorisé. Veuillez choisir un mot de passe différent."
  }
} as const;
